<template>
  <nav class="sidebar">
    <div v-for="(link, l) in links" :key="l" class="flex flex-row gap-1">
      <div v-if="link.items" class="sidebar-dropdown" @mouseenter="showMenu(link.name)" @mouseleave="showMenu(link.name)">
                <span class="sidebar-dropdown-button span" :style="route.path === link.href ? 'color: rgb(30, 116, 251)' : ''">
                    {{t(link.name)}}<v-icon>mdi-chevron-down</v-icon>
                </span>
        <div class="sidebar-dropdown-menu" v-if="isMenuVisible[link.name]">
          <template v-for="(item, index) in link.items" :key="item.name">
            <router-link :to="item.href" v-if="!item.target"
                         class="sidebar-dropdown-item span" v-html="t(item.name)"
                         :style="route.path === item.href ? 'color: rgb(30, 116, 251)' : ''"/>
            <a v-else :href="item.href" class="sidebar-dropdown-item span" target="_blank" rel="noopener noreferrer"
               :key="`external-${index}`" @click.stop>
              {{ t(item.name) }}
            </a>
          </template>
        </div>
      </div>
      <router-link v-else :to="link.href" :style="route.path === link.href ? 'color: rgb(30, 116, 251)' : ''">
        <span class="span">{{t(link.name)}}</span>
      </router-link>
    </div>
  </nav>
</template>

<script setup>
import {ref} from "vue";
import {useI18n} from "vue-i18n";
import {useRoute} from "vue-router";

const {t} = useI18n();
const route = useRoute();
let links = ref([
  {name: 'main', href: '/'},
  {name: 'about', href: '/about/position', items: [
      {name: 'position', href: '/about/position'},
      {name: 'management', href: '/about/management'},
      {name: 'structure', href: '/about/structure'},
      {name: 'photoGallery', href: '/about/photo'},
      {name: 'videoGallery', href: '/about/video'},
      {name: 'media', href: '/about/media'},
      {name: 'bankReq', href: '/about/bank'},
    ]},
  {name: 'regulatoryFramework', href: '/regulatory_framework/legislation', items: [
      {name: 'legislation', href: '/regulatory_framework/legislation'},
      {name: 'decrees', href: '/regulatory_framework/decrees'},
      {name: 'resolution', href: '/regulatory_framework/resolution'},
      {name: 'governmentDecrees', href: '/regulatory_framework/gov-decrees'},
      {name: 'regulatoryLegalActsOfStateBodies', href: '/regulatory_framework/regulatory-legal-acts'},
      {name: 'orders', href: '/regulatory_framework/orders'},
      {name: 'regulations', href: '/regulatory_framework/regulations'},
    ]},
  {name: 'activity', href: '/activity/accounting', items: [
      {name: 'ourActivity5Name', href: '/activity/accounting'},
      {name: 'leaseOfStateProperty', href: '/activity/lease-of-state-property'},
      {name: 'propertyRelations', href: '/activity/property-relations'},
      {name: 'companies', href: '/activity/companies'},
      {name: 'businessEntities', href: '/activity/business-entities'},
      {name: 'court-proceedings', href: '/activity/court-proceedings'},
      {name: 'investors', href: '/activity/investors'},
      {name: 'ourActivity2Name', href: '/activity/purchases'},
    ]},
  {name: 'corruption', href: '/corruption', items: [
      {name: 'corruption', href: '/corruption'},
      {name: 'regulatory-legal', href: '/corruption/regulatory-legal'},
      {name: 'methodical-recommendations', href: '/corruption/methodical-recommendations'},
      {name: 'anti-corruption-doc-form', href: '/corruption/anti-corruption-doc-form'},
      {name: 'corruption-report', href: '/corruption/corruption-report'},
      {name: 'presantation', href: '/corruption/presantation'},
      {name: 'feedback-reporting', href: '/corruption/feedback-reporting'},
      {name: 'organizational-events', href: '/corruption/organizational-events'},
    ]},
  {name: 'smi', href: '/media/news', items: [
      {name: 'news', href: '/media/news'},
      {name: 'competitions', href: '/media/competitions'},
      {name: 'vacancies', href: '/media/vacancies'},
      {name: 'government-z', href: 'http://zakupki.gov.kg/popp/', target: '_blank'},
    ]},
  {name: 'contacts', href: '/contacts/phone-directory', items: [
      {name: 'phone-directory', href: '/contacts/phone-directory'},
      {name: 'public-reception', href: '/contacts/public-reception'},
      {name: 'electronic-appeals', href: '/contacts/electronic-appeals'},
    ]},
]);

let isMenuVisible = ref({
  standard: false,
  registryMain: false
});

function showMenu (type) {
  isMenuVisible.value[type] = !isMenuVisible.value[type];
}
</script>
